import React, { useState, useCallback } from "react";
import { Form } from "react-bootstrap";

// TopicsInput component for managing topics
export default function TopicsInput({
  topics,
  onChange,
  onBlur,
  className = "",
  isInvalid = false,
  isValid = false,
  id,
}) {
  const [newTopic, setNewTopic] = useState("");

  const handleAddTopic = useCallback(() => {
    const trimmedTopic = newTopic.trim();
    if (trimmedTopic && !topics.includes(trimmedTopic)) {
      onChange([...topics, trimmedTopic]);
      setNewTopic("");
    }
  }, [newTopic, topics, onChange]);

  function handleRemoveTopic(topicToRemove) {
    onChange(topics.filter((topic) => topic !== topicToRemove));
  }

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleAddTopic();
      }
    },
    [handleAddTopic],
  );

  const handleTopicInputChange = useCallback((e) => {
    setNewTopic(e.target.value);
  }, []);

  const handleTopicInputBlur = useCallback(() => {
    if (onBlur) {
      onBlur(topics);
    }
  }, [onBlur, topics]);

  return (
    <div className={className}>
      <div className="input-group mb-2">
        <Form.Control
          type="text"
          id={id}
          value={newTopic}
          onChange={handleTopicInputChange}
          onKeyDown={handleKeyDown}
          onBlur={handleTopicInputBlur}
          placeholder="Enter a topic..."
          className="bg-white"
          isInvalid={isInvalid}
          isValid={isValid}
          autoComplete="off"
          data-dashlane-ignore="true"
        />
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={handleAddTopic}
          disabled={!newTopic.trim() || topics.includes(newTopic.trim())}
        >
          <i className="fa fa-plus" aria-hidden="true" />
        </button>
      </div>

      {topics.length > 0 && (
        <div className="d-flex flex-wrap gap-2">
          {topics.map((topic) => (
            <span key={topic} className="badge bg-light text-dark border d-flex align-items-center gap-1">
              {topic}
              <button
                type="button"
                className="btn-close btn-close-sm"
                style={{ fontSize: "0.6em" }}
                onClick={() => handleRemoveTopic(topic)}
                aria-label={`Remove ${topic}`}
              />
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
